import { DATACENTRAL_API_URL } from "../utils/constants";
import { requestWithToken } from "../utils/functions";
import { useQuery } from "react-query";

export async function getPaymentClientToken(method: string) {
  const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/payments/method/grant/${method}`)

  return response?.data
}

export async function createPaymentCustomer(payload: any) {
  return await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/payments`, 'POST', {
    payment: payload
  })
}

export function getCustomerPaymentMethods(identifer: string) {
  return useQuery(["account.customer.payment", identifer], async () => {
    const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/payments/${identifer}`)

    return response?.data?.data?.payment_methods
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    suspense: true,
    enabled: !!localStorage.getItem('SA')
  })
}

export function getCustomerPaymentMethod(id: string) {
  return useQuery(["account.customer.payment.method", id], async () => {
    const response = await requestWithToken(`${DATACENTRAL_API_URL}/workers/v2/payments/method/${id}`)

    return response?.data?.data?.payment_method
  }, {
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    retry: false,
    staleTime: 30 * 1000,
    suspense: true,
    enabled: !!id
  })
}